import { useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Button, EmptyState } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import triggersPreviewImg from 'shared/assets/images/triggers/triggers_preview.png'
import { LINK_TRIGGERS_HELP_GUIDE } from 'shared/constants/links'
import { TriggersRoutes } from 'entities/ExportRouters'
import styles from './styles.module.scss'

export const EmptyStateTriggers = observer(() => {
  const navigate = useNavigate()
  const onClick = () => {
    navigate(`/${TriggersRoutes.root}/${TriggersRoutes.create}`)
  }

  return (
    <EmptyState
      variant={'preview'}
      previewImg={<img alt='ButtonTrigger preview' src={getCDNAssetURL(triggersPreviewImg)} />}
      title={'Create your first trigger'}
      subtitle={'Send instant messages via API or webhooks'}
      actions={
        <>
          <Button
            text={'New trigger'}
            onClick={onClick}
            iconProps={{ icon: 'add' }}
            size={'medium'}
          />
          <Button
            tag='a'
            text='Help guide'
            size='medium'
            contained='secondary'
            iconProps={{ icon: 'info' }}
            className={styles.helpButton}
            href={LINK_TRIGGERS_HELP_GUIDE}
            target='_blank'
            rel='noreferrer'
          />
        </>
      }
    />
  )
})
